import React from 'react'
import TaskComponent from './TaskSection/TaskList'

function TaskPage() {
  return (
    <div><TaskComponent/></div>
  )
}

export default TaskPage